module.exports = __webpack_public_path__ + "img/P10_IS13-2018-0004-010.b00c4c4a.jpg";